import { Capacitor } from "@capacitor/core";
import React from "react";
import { getDeviceType } from "../utils/DeviceUtils";
import { parseUrl } from "../utils/parseUrl";

export default function StoreRedirect() {
  React.useEffect(() => {
    if (Capacitor.getPlatform() !== "web") {
      return;
    }

    const { pageName } = parseUrl(window.location.href);

    // not a "deep link"
    if (pageName === undefined) {
      return;
    }

    const deviceType = getDeviceType();

    if (deviceType === "android") {
      return redirectToStore("google");
    }

    if (deviceType === "ios-mobile" || deviceType === "ios-safari") {
      return redirectToStore("apple");
    }
  }, []);

  return null;
}

function redirectToStore(store: "apple" | "google") {
  switch (store) {
    case "google":
      document.location.href = "market://launch?id=com.medflyt.iphone";
      break;

    case "apple":
      document.location.href = "itms-apps://apps.apple.com/us/app/medflyt/id1165814775";
      break;
  }
}
